import {
  Component,
  ElementRef,
  ViewChild,
  inject,
  OnInit
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {MatCardModule} from '@angular/material/card';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {FleetsService} from '../../_services/fleets.service';
import {Constants} from '../../helpers/constants';
import {DatesHelper, ImplementationStatus, LoginHelper, Role, StringsHelper} from '../../helpers';
import {
  FleetDashboardWidget,
  FleetBage,
  Fleet,
  FleetImage,
  FleetDashboardWidgetDetail
} from '../../_models/fleet.models';
import {ActivatedRoute, Router} from '@angular/router';
import {ProjectService, ProjectControlItemService, ClientProfileService} from '../../_services';
import {ClientITProfile, Project, ProjectControlItem} from '../../_models';
import {EvidenceRecurring} from '../../helpers/evidenceRecurring';
import * as moment from "moment";
import {Policy} from '../../_models/policy';
import {PolicyService} from "../../_services/policy.service";

interface GalleryImage {
  id: number;
  name: string;
  url: string;
}

@Component({
  selector: 'fleetDashboardDetail',
  standalone: false,
  templateUrl: './fleet.dashboard.detail.component.html',
  styleUrls: ['./fleet.dashboard.detail.component.scss']
})

export class FleetDashboardDetailComponent implements OnInit {
  @ViewChild('thumbnailRow') thumbnailRow!: ElementRef<HTMLDivElement>;
  api: string;
  token: string;
  fleetId: number;
  selectedFleet: FleetDashboardWidgetDetail;
  selectedProject: Project;
  controlItems: ProjectControlItem[];
  expandedSmallItem = {};
  anyAreaWithLevels: any;
  anyAreaWithFedRamp: any;
  projectControlItems: any;
  policies: Policy[];
  project: any;
  clients: any;
  assignedVendorUsers: any;
  assignedNonVendorUsers: any;
  config: any;
  settings: any;
  itProfiles: ClientITProfile[] = [];
  currentProfiles: ClientITProfile[] = [];
  currentDiagrams: any[];
  currentDiagram: any;
  currentPositions: any[];
  implementationStatuses: any =
    {
      0: "None",
      1: "Implemented",
      2: "Partially Implemented",
      3: "Planned",
      4: "Alternative Implementation",
      5: "Not Applicable",
      7: "Not Implemented"
      //6: "Ongoing",
    };

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.fleetId = params['fleetId'];
    });

    this.clientProfileService.getPublicSettings(LoginHelper.getTenantName()).subscribe({
      next: settings => {
        this.settings = settings;
      }
    });

    this.clientProfileService.getClientProfiles(LoginHelper.getTenantName()).subscribe({
      next: profiles => {
        this.itProfiles = profiles;
        this.loadFleet(this.fleetId);
      }
    });
  }

  constructor(
    public fleetsService: FleetsService,
    private route: ActivatedRoute,
    private router: Router,
    public projectService: ProjectService,
    public policyService: PolicyService,
    public projectControlItemService: ProjectControlItemService,
    public clientProfileService: ClientProfileService,
  ) {
    this.api = window.location.origin || Constants.DefaultApiHost;
    this.token = LoginHelper.getFileToken();
  }

  loadFleet(fleetId: number): void {
    this.policyService.getAllPolicys().subscribe(p => {
      this.policies = p;
    })
    this.fleetsService.getDashboardDetail(fleetId).subscribe({
      next: fleet => {
        this.selectedFleet = fleet;
        //this.selectedProject = this.selectedFleet?.projects?.length > 0 ? this.selectedFleet.projects[0] : null;
        //this.controlItems = this.processProjectControlItems(this.selectedProject.projectControlItems);
      }
    });
  }

  selectProject(project: Project) {
    if (project === this.selectedProject) {
      this.selectedProject = null;
    } else {
      this.selectedProject = project;
      this.controlItems = this.processProjectControlItems(this.selectedProject.projectControlItems);
      this.updateDiagram();
    }
  }

  backToDashboard(): void {
    this.router.navigate(
      ['/']);
  }

  scrollThumbnails(direction: number): void {
    this.thumbnailRow.nativeElement.scrollBy({
      left: direction * 250,
      behavior: 'smooth'
    });
  }

  updateDiagram(diagram = null) {
    this.currentProfiles = (this.selectedProject.clientITProfileIds || '').split(';').map(i => this.itProfiles.find(p => p.clientITProfileId == parseInt(i, 10))).filter(p => p);
    this.currentDiagrams = this.currentProfiles.flatMap(p => p.diagrams);
    this.currentDiagram = diagram || this.currentDiagrams[0];
    this.currentPositions = this.currentProfiles.flatMap(p => p.devices).flatMap(d => d.devicePositions.map(s => ({
      ...s,
      deviceName: d.deviceName
    }))).filter(p => p.diagramId === this.currentDiagram.id);
    if (/\.(jpg|jpeg|png|gif|webp|svg|bmp)$/i.test(this.currentDiagram.name)) {
      this.currentDiagram.imageUrl = '/api/attachments/file?name=' + encodeURIComponent(this.currentDiagram.internalName) + '&path=' + encodeURIComponent('Account/IT Profile/') + '&token=' + LoginHelper.getFileToken();
    } else {
      this.currentDiagram.diagram3dUrls = [{
        url: '/api/attachments/file?name=' + encodeURIComponent(this.currentDiagram.internalName) + '&path=' + encodeURIComponent('Account/IT Profile/') + '&token=' + LoginHelper.getFileToken(),
        file: this.currentDiagram.internalName
      }];
    }
  }

  getImageUrl(fileName: string): string {
    if (!fileName || fileName == "") {
      return `data:image/svg+xml;utf8,
        <svg xmlns='http://www.w3.org/2000/svg' width='160' height='160' viewBox='0 0 160 160'>
          <rect width='160' height='160' rx='18' fill='%23f3f4f6' />

          <rect x='45' y='50' width='70' height='60' rx='12' fill='%236366f1' />
          <circle cx='65' cy='75' r='8' fill='white' />
          <circle cx='95' cy='75' r='8' fill='white' />
          <rect x='65' y='92' width='30' height='6' rx='3' fill='white' />

          <line x1='80' y1='50' x2='80' y2='32' stroke='%23374151' stroke-width='5' />
          <circle cx='80' cy='28' r='7' fill='%23ef4444' />

          <rect x='28' y='68' width='14' height='32' rx='7' fill='%236366f1' />
          <rect x='118' y='68' width='14' height='32' rx='7' fill='%236366f1' />

          <rect x='58' y='112' width='12' height='22' rx='6' fill='%23374151' />
          <rect x='90' y='112' width='12' height='22' rx='6' fill='%23374151' />
        </svg>`;
    }
    return `${this.api}/api/attachments/file?name=${encodeURIComponent(fileName)}&asImage=true&path=Account/Fleets&token=${this.token}`;
  }

  processProjectControlItems(projectControlItems: ProjectControlItem[]): ProjectControlItem[] {
    projectControlItems.forEach(projectControlItem => {
      let i;
      this.anyAreaWithLevels = this.anyAreaWithLevels || projectControlItem.controlItem.complianceArea.hasLevels;
      this.anyAreaWithFedRamp = this.anyAreaWithFedRamp || projectControlItem.controlItem.complianceArea.isFedRamp;
      const parent = projectControlItems.find(i => i.controlItem.controlItemId == projectControlItem.controlItem.parentControlItemId);
      if (parent) {
        (<any>projectControlItem).parentName = parent.controlItem.category + ' - ' + parent.controlItem.complianceAreaControlId;
      }
      (<any>projectControlItem).policies = projectControlItem.projectControlItemPolicies && projectControlItem.projectControlItemPolicies.length > 0 ? projectControlItem.projectControlItemPolicies.map(projectControlItemPolicy => this.policies.find(p => projectControlItemPolicy.policyId == p.id)).filter(i => i) : [];
      (<any>projectControlItem).implementationStatusText = this.implementationStatuses[projectControlItem.implementationStatus];
      projectControlItem.assignedClient.fullName = projectControlItem.assignedClient.firstName + " " + projectControlItem.assignedClient.lastName;
      this.updateScore(projectControlItem);
      projectControlItem.subItems = projectControlItems.filter(i => i.controlItem.parentControlItemId == projectControlItem.controlItem.controlItemId && (!this.project.isPartner || i.assignedClientId == projectControlItem.assignedClientId))
        .sort((a, b) =>
          a.controlItem.level > b.controlItem.level ? 1 : a.controlItem.level < b.controlItem.level ? -1 :
            a.controlItem.complianceAreaControlId > b.controlItem.complianceAreaControlId ? 1 : -1);
      projectControlItem.subItemLevels = [];
      (<any>projectControlItem).implementationStatusStyle = (projectControlItem.implementationControlStatusNotNeeded || projectControlItem.implementationStatus == ImplementationStatus.Implemented || projectControlItem.implementationStatus == ImplementationStatus.AlternativeImplementation) ? 'green' :
        (projectControlItem.implementationStatus == ImplementationStatus.PartiallyImplemented || projectControlItem.implementationStatus == ImplementationStatus.Planned) ? 'yellow' :
          projectControlItem.implementationStatus == ImplementationStatus.NotApplicable ? 'gray' : 'red';
      (<any>projectControlItem).evidencesStyle = projectControlItem.evidenceNotNeeded ? 'gray' :
        (projectControlItem.evidences && projectControlItem.evidences.length && (projectControlItem.evidenceFrequency == EvidenceRecurring.None || projectControlItem.evidenceFrequency == EvidenceRecurring.OneTime))
        || (projectControlItem.evidenceFrequency > EvidenceRecurring.OneTime
          && projectControlItem.evidences.find(e =>
            moment(e.date).isSameOrAfter(moment().add(-1,
              projectControlItem.evidenceFrequency == EvidenceRecurring.Daily ? 'day' :
                projectControlItem.evidenceFrequency == EvidenceRecurring.Weekly ? 'week' :
                  projectControlItem.evidenceFrequency == EvidenceRecurring.Monthly ? 'month' :
                    projectControlItem.evidenceFrequency == EvidenceRecurring.Quarterly ? 'quarter' : 'year')))) ? 'green' : 'red';
      (<any>projectControlItem).gapStyle = projectControlItem.actionPlans.find(a => a.currentStatus != 2 && a.riskLevel == 'High') ? 'red' :
        projectControlItem.actionPlans.find(a => a.currentStatus != 2 && a.riskLevel == 'Medium') ? 'orangestatus' :
          projectControlItem.actionPlans.find(a => a.currentStatus != 2 && a.riskLevel == 'Low') ? 'yellow' : 'gray';
      (<any>projectControlItem).gapCount = projectControlItem.actionPlans.filter(a => a.currentStatus != 2 && a.riskLevel).length.toString(10);
      let currentLevel = "";
      for (i = 0; i < projectControlItem.subItems.length; i++) {
        projectControlItem.subItems[i].hasParent = true;
        if (projectControlItem.subItems[i].controlItem.level != currentLevel) {
          currentLevel = projectControlItem.subItems[i].controlItem.level;
          const newSubItemLevel = {subItems: [], level: currentLevel};
          projectControlItem.subItemLevels.push(newSubItemLevel);
        }
        projectControlItem.subItemLevels[projectControlItem.subItemLevels.length - 1].subItems.push(projectControlItem.subItems[i]);
      }
      projectControlItem.upcomingDueDate = this.getUpcomingDate(projectControlItem).format('Y-MM-DDT00:00:00');
      projectControlItem.previousDueDate = this.getPreviousDate(projectControlItem).format('Y-MM-DDT00:00:00');
      projectControlItem.currentRangeCompleted = (projectControlItem.completionPeriods.find(i => moment(i.dueDate + 'Z').isSame(projectControlItem.upcomingDueDate + 'Z')) || {isCompleted: false}).isCompleted;


      projectControlItem.originalCompletionPeriods = JSON.parse(JSON.stringify(projectControlItem.completionPeriods));
      projectControlItem.originalreviewedByConsultantDates = Object.assign([], projectControlItem.reviewedByConsultantDates);
    });
    return projectControlItems;
  }

  updateScore(projectControlItem) {
    projectControlItem.dynamicScore =
      (projectControlItem.solutionDescription || projectControlItem.solutionDescription2 || projectControlItem.solutionDescription3 ? this.settings.implementationStatusScore : 0) +
      (projectControlItem.evidences.length ? this.settings.evidenceScore : 0) +
      (projectControlItem.policies.length ? this.settings.policyScore : 0) +
      (projectControlItem.actionPlans.find(a => a.status !== 'Resolved') ? 0 : this.settings.poamScore);
  }

  public getUpcomingDate(projectControlItem): moment.Moment {
    const ranges = DatesHelper.getDates(projectControlItem);
    const now = moment().startOf('day').add(15, 'hour');
    const closest = ranges.reverse().find(i => i.date.isSameOrAfter(now, 'day') && !projectControlItem.completionPeriods.find(d => d.isCompleted && moment(d.dueDate).isSame(i.value + "Z")));
    return (closest || ranges[0]).date;
  }

  public getPreviousDate(projectControlItem): moment.Moment {
    const ranges = DatesHelper.getDates(projectControlItem).reverse();
    const now = moment().startOf('day').add(15, 'hour');
    const upcomingNum = ranges.indexOf(ranges.find(i => i.date.isSameOrAfter(now, 'day') && !projectControlItem.completionPeriods.find(d => d.isCompleted && moment(d.dueDate).isSame(i.value + "Z"))));
    if (upcomingNum <= 0) return moment().add(-1, 'day');
    const previous = ranges[upcomingNum - 1];
    return previous.date;
  }
}
